import { FC } from 'react';
import { SelectInputPositionByDepartmentProvider } from 'modals/JaneDetailsModal/views/EditJaneView/SelectInputPositionByDepartment/SelectInputPositionByDepartment.context';
import { RemovePositionModalComponent } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/RemovePositionModal.component';
import {
  RemovePositionUIProvider,
  useRemovePositionModalUIContext,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/RemovePositionModal.ui.context';
import { TeamMemberPageProvider } from 'pages/TeamMembers/Internal/TeamMemberPage.context';
import { FetchAssignedGroupedPositionsProvider } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/FetchAssignedGroupedPositions.data.context';
import { PositionsAllocationSettingsPageDataProvider } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/PositionsAllocationSettingsPage.data.context';
import { useLocation } from 'react-router-dom';

const RemovePositionModalLocation: FC<{ facility_id: string }> = ({ facility_id }) => {
  const { positionId, isOpen } = useRemovePositionModalUIContext();
  if (!isOpen || !positionId) return null;
  return (
    <TeamMemberPageProvider locationId={facility_id}>
      <SelectInputPositionByDepartmentProvider allocatedToCommunities={[facility_id]}>
        <PositionsAllocationSettingsPageDataProvider>
          <FetchAssignedGroupedPositionsProvider>
            <RemovePositionModalComponent />
          </FetchAssignedGroupedPositionsProvider>
        </PositionsAllocationSettingsPageDataProvider>
      </SelectInputPositionByDepartmentProvider>
    </TeamMemberPageProvider>
  );
};

export const RemovePositionModal: FC = () => {
  const { pathname } = useLocation();
  const facility_id = pathname.split('/')[3];

  return (
    <RemovePositionUIProvider>
      {facility_id && <RemovePositionModalLocation key={facility_id} facility_id={facility_id} />}
    </RemovePositionUIProvider>
  );
};
